export const generateEmailValidateRegexp = () =>
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

export const generatePasswordRegexp = () => /^[a-zA-Z0-9#$%&'()*+,./:;<=>?@[\]^_`{|}~-]+$/i;

export const generateLineTagRegexp = () => /^[a-zA-Z0-9-]+$/;
